import DeleteIcon from '@mui/icons-material/Delete';
import {
  Box,
  Button,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material';
import { FunctionComponent } from 'react';

import { EventBedroomsQuery } from '../../../../../apollo/__generated__/graphql';
import { Tooltip } from '../../../../../components/Tooltip';
import { EventUsersDrawer } from '../../../../../user/components/EventUsersDrawer/EventUsersDrawer';
import { useBedroomUsersDrawer } from './useBedroomUsersDrawer';

type Bedroom = EventBedroomsQuery['eventBedrooms'][number];

interface BedroomUsersDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  eventId: string;
  bedroom: Bedroom;
}

export const BedroomUsersDrawer: FunctionComponent<BedroomUsersDrawerProps> = ({
  isOpen,
  onClose,
  eventId,
  bedroom,
}) => {
  const {
    onRemoveUser,
    isEventUsersDrawerOpen,
    onCloseEventUsersDrawer,
    onAddUserToBedroom,
    openEventUsersDrawer,
  } = useBedroomUsersDrawer(eventId, bedroom.id);

  return (
    <>
      <Drawer anchor="right" open={isOpen} onClose={onClose}>
        <Box sx={{ mt: 10, mx: 2, width: 360 }}>
          <Typography variant="h4">{`Utilisateurs dans la chambre ${bedroom.doorNumber}`}</Typography>
          <List sx={{ width: '100%', bgcolor: 'background.paper' }}>
            {bedroom.users.map((user) => (
              <div key={user.id}>
                <ListItem
                  alignItems="flex-start"
                  secondaryAction={
                    <Tooltip title="Retirer de la chambre">
                      <IconButton
                        color="error"
                        onClick={() => onRemoveUser(user.id)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </Tooltip>
                  }
                >
                  <ListItemText
                    primary={`${user.firstname} ${user.lastname}${user.nickname ? ` (${user.nickname})` : ''}`}
                    secondary={
                      <Box flexDirection="column" display="flex">
                        <Typography
                          component="span"
                          variant="body2"
                          sx={{ color: 'text.primary', display: 'inline' }}
                        >
                          {user.studyTown}
                        </Typography>
                      </Box>
                    }
                  />
                </ListItem>
                <Divider component="li" />
              </div>
            ))}
          </List>
          <Button variant="outlined" fullWidth onClick={openEventUsersDrawer}>
            {"Ajouter quelqu'un dans la chambre"}
          </Button>
        </Box>
      </Drawer>
      <EventUsersDrawer
        eventId={eventId}
        isOpen={isEventUsersDrawerOpen}
        onClose={onCloseEventUsersDrawer}
        onUserSelected={onAddUserToBedroom}
      />
    </>
  );
};
